.row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 10px 18px;
  border-top: 1.5px solid var(--line);
  color: var(--ink);
  text-decoration: none;
}

.row:first-of-type {
  border-top: 0;
}

.main {
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 44px;
}

.lines {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.name {
  font-size: 16px;
  font-weight: 600;
}

.detail {
  font-size: 14px;
  color: var(--ink-2);
}

.chip {
  flex: 0 0 auto;
  padding: 3px 10px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  background: var(--surface);
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

/* Waiting for the patient: grey and dashed, like a day still to come. */
.waiting {
  border-style: dashed;
  background: var(--sunk);
}

/* The accent keeps its colour in both themes, so the text on it stays dark
 * rather than following --ink. */
.submitted {
  background: var(--accent);
  color: var(--accent-ink);
}

.action {
  flex: 0 0 auto;
  min-height: 44px;
  padding: 0 14px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
}

.action:disabled {
  background: var(--sunk);
  color: var(--ink-3);
  cursor: default;
}

.error {
  font-size: 14px;
  font-weight: 600;
  color: var(--error);
}

.chevron {
  flex: 0 0 auto;
  width: 18px;
  height: 18px;
  background-color: var(--ink-3);
  -webkit-mask: url('./chevron.svg') no-repeat center / contain;
  mask: url('./chevron.svg') no-repeat center / contain;
}
